import { render, staticRenderFns } from "./ListTypePerson.vue?vue&type=template&id=6c616780"
import script from "./ListTypePerson.vue?vue&type=script&lang=js"
export * from "./ListTypePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports